import { Capacitor } from '@capacitor/core';
import { KeyboardNube } from '@tiendanube/capacitor-keyboard-nube';
import { LoginResponseDto } from '@tiendanube/common';

export const setConfigKeyboard = ({
  accessToken,
  defaultLanguage,
}: LoginResponseDto): void => {
  if (Capacitor.getPlatform() === 'web') return;

  KeyboardNube.setToken({
    token: accessToken,
  });

  KeyboardNube.setLocale({
    locale: defaultLanguage,
  });
};

export const cleanupKeyboardConfig = (): void => {
  if (Capacitor.getPlatform() === 'web') return;
  KeyboardNube.setToken({ token: null });
};
